import React from "react";
import Accordion from "../Accordion/Accordion";
import { getPhaseTitle, getActivities, isPhaseValidate } from "./FormFormat";

const FormByAccordion = (props) => {
  const { touched, phases, errors, onPhaseToggle, formShowPendingCount } = props;
  return phases.map((phase, index) => {
    const { title, phaseNo, isActive, description, elements } = phase;
    return (
      <Accordion
        key={phaseNo}
        isActive={isActive === undefined && index === 0 ? true : isActive}
        isPhaseValidate={isPhaseValidate(elements, touched, errors)}
        title={getPhaseTitle(title, elements, formShowPendingCount)}
        content={getActivities({
          touched,
          errors,
          description,
          elements,
          ...props,
          phaseNo,
        })}
        onPhaseToggle={() => onPhaseToggle(phase)}
      />
    );
  });
};

export default FormByAccordion;
